"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Type = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CallingIcon = function CallingIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.643 14.678C.603 13.666.58 13.03.57 12.77c-.058-1.44.795-2.505 2.561-3.198 2.65-1.04 10.053-2.493 20.103.206 2.364.454 3.368 1.943 3.16 3.272-.138.886-.262 1.744-.372 2.573-.24 1.035-1.005 1.435-2.293 1.2-1.933-.352-1.288-.265-2.837-.582-1.549-.317-1.397-.448-2.1-2.175-.701-1.726-.278-2.158-2.645-2.254-1.578-.064-3.666-.082-6.265-.054-.918-.045-1.483.5-1.695 1.636-.317 1.703-.707 2.08-2.517 2.43a29.29 29.29 0 0 1-3.464.472C1.204 16.23.683 15.69.643 14.678zM27.452 6.63c1.667.239 2.57 1.185 2.707 2.839m-1.627-5.805c2.8.402 4.316 1.992 4.548 4.77M29.766.861c3.744.537 5.77 2.663 6.08 6.376",
    fill: "none",
    stroke: "#FFF"
  }));
};
CallingIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 37 18"
};
var Type = exports.Type = {
  INCOMING: 'incoming',
  OUTGOING: 'outgoing'
};
var CallingState = exports["default"] = /*#__PURE__*/function (_React$PureComponent) {
  function CallingState(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CallingState);
    _this = _callSuper(this, CallingState, [props]);
    _this.state = {
      isClicked: false
    };
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(CallingState, _React$PureComponent);
  return (0, _createClass2["default"])(CallingState, [{
    key: "handleSubmit",
    value: function handleSubmit(event) {
      event.preventDefault();
      var onSubmit = this.props.onSubmit;
      onSubmit();
      this.setState({
        isClicked: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        contact = _this$props.contact,
        type = _this$props.type,
        isInterception = _this$props.isInterception;
      var fullName = contact.fullName,
        number = contact.number;
      var isClicked = this.state.isClicked;
      var isIncoming = type === Type.INCOMING;
      var acceptTitle = '';
      if (isClicked) {
        acceptTitle = isIncoming ? 'Соединение...' : 'Отмена...';
      } else {
        acceptTitle = isIncoming ? 'Ответить' : 'Отменить';
      }
      var callLabel = '';
      if (isInterception) {
        callLabel = 'Приглашение в разговор от сотрудника';
      } else {
        callLabel = type === Type.INCOMING ? 'Входящий звонок' : 'Исходящий звонок';
      }
      return /*#__PURE__*/_react["default"].createElement(StyledCallingState, {
        className: className,
        onSubmit: this.handleSubmit,
        type: type
      }, /*#__PURE__*/_react["default"].createElement(StyledContent, null, /*#__PURE__*/_react["default"].createElement(CallingIcon, {
        width: 37
      }), /*#__PURE__*/_react["default"].createElement(StyledInfo, null, fullName && /*#__PURE__*/_react["default"].createElement("span", null, fullName), number && /*#__PURE__*/_react["default"].createElement("span", null, number), !fullName && !number && /*#__PURE__*/_react["default"].createElement("span", null, callLabel)), /*#__PURE__*/_react["default"].createElement(StyledAccept, {
        disabled: isClicked
      }, acceptTitle)));
    }
  }]);
}(_react["default"].PureComponent);
CallingState.propTypes = {
  className: _propTypes["default"].string,
  onSubmit: _propTypes["default"].func.isRequired,
  isInterception: _propTypes["default"].bool,
  contact: _propTypes["default"].shape({
    fullName: _propTypes["default"].string,
    number: _propTypes["default"].number
  }),
  type: _propTypes["default"].oneOf(Object.values(Type))
};
CallingState.defaultProps = {
  className: '',
  contact: null,
  isInterception: false,
  type: Type.INCOMING
};
var StyledCallingState = _styledComponents["default"].form.withConfig({
  displayName: "Calling__StyledCallingState",
  componentId: "sc-2jr1x8-0"
})(["background-image:linear-gradient(to left,#00e04b,#00b0b6);height:100%;width:100%;", ""], function (props) {
  return props.type === Type.OUTGOING && "\n    background-image: linear-gradient(to left, #faed61, #f7aa1b);\n  ";
});
var StyledContent = _styledComponents["default"].div.withConfig({
  displayName: "Calling__StyledContent",
  componentId: "sc-2jr1x8-1"
})(["align-items:center;display:flex;height:100%;justify-content:center;width:100%;"]);
var StyledInfo = _styledComponents["default"].div.withConfig({
  displayName: "Calling__StyledInfo",
  componentId: "sc-2jr1x8-2"
})(["color:#fff;margin-left:15px;> span{display:block;font-size:12px;}> span:first-child{font-size:17px;}"]);
var StyledAccept = _styledComponents["default"].button.withConfig({
  displayName: "Calling__StyledAccept",
  componentId: "sc-2jr1x8-3"
})(["background-color:#fff;border:none;border-radius:30px;color:#17181a;cursor:pointer;font-size:14px;line-height:40px;padding:0 43px;font-weight:500;", " + &{margin-left:24px;}", ""], StyledInfo, function (props) {
  return props.disabled && "\n    cursor: default;\n    opacity: 0.5;\n  ";
});